<template>
  <div v-if="winStreak > 0">
    <b-tooltip :label="`Winning streak: ${winStreak}`" type="is-success">
      <span class="tag is-success is-light rating" :class="`rating--${type}`">
        ✨ {{ winStreak }}
      </span>
    </b-tooltip>
  </div>
</template>

<script>
export default {
  name: "WinStreak",
  props: ["winStreak", "type"],
};
</script>

<style scoped>
.rating {
  padding: 0 0.15rem;
}

.rating--large {
  font-size: 1.5em;
}
</style>
